export default {
  title: '通知',
  centerTitle: '待处理事项',
  pendingCount: '待处理通知',
  normalNotice: '普通',
  importantNotice: '重要',
  criticalNotice: '紧急',
  noticeTypeAnnouncement: '公告',
  noticeTypeDataOverwrite: '数据覆盖',
  noticeTypeUpgrade: '系统升级',
  noticeTypeVote: '投票',
  noticeTypeSurvey: '问卷',
  noticeTypeResearch: '调研',
  ack: '我已知悉',
  applyDelay: '申请延期',
  selectDelayTime: '请选择延期时间',
  feedback: '反馈',
  feedbackPlaceholder: '请输入反馈内容',
  feedbackRequired: '请输入反馈内容',
  survey: '问卷调查',
  answerPlaceholder: '请输入答案',
  answerRequired: '请完成必填题目',
  openLink: '查看详情',
  submitSuccess: '提交成功',
  forceShowCloseBlocked: '当前通知为强制显示，请按通知要求处理后再关闭。'
};
